<template>
    <div class="pv4 bb b--light-gray ph3 ph4-ns bg-near-white">

        <div>

            <!-- back link -->
            <router-link v-if="linkText !== null && smallOrLess" :to="route" class="no-underline">
                <BackLink >{{linkText}}</BackLink>
            </router-link>

            <div class="flex items-center justify-between">

                <!-- heading -->
                <h4 class="mt1">{{headingText}}</h4>

                <div v-if="count" class="flex items-center">
                    <Pill :count="count"/>
                    <!-- forward link -->
                    <router-link v-if="forwardRoute !== ''" :to="forwardRoute" class="ml2 no-underline">
                        <ForwardLink>{{forwardText}}</ForwardLink>
                    </router-link>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import Pill from '@/components/controls/Pill.vue';
import BackLink from '@/components/controls/BackLink.vue';
import ForwardLink from '@/components/controls/ForwardLink.vue';

export default {
    components: {
        BackLink,
        ForwardLink,
        Pill
    },
    props: {
        headingText: {
            type: String
        },
        linkText: {
            type: String,
            default: null
        },
        route: {
            type: String
        },
        forwardText: {
            type: String
        },
        forwardRoute: {
            type: String
        },
        count: {
            type: Number
        }
    },
    computed: {
        smallOrLess() {
            return this.$mq === 'xs' || this.$mq === 'sm';
        }
    }
};
</script>
